import React, {Component} from 'react';
import {Card, CardBody, CardHeader} from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {getData} from '../../api/doLogin.js';

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class ApplicationsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataLoaded: false
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 5,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }

  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type) {
      this.updateData();
    }
  }

  updateData() {
    var self = this;
    getData("applications/list", {}, this.props.token)
      .then((data) => {
        if (data.status == "Success") {
          self.setState({data: data.data.intakes, dataLoaded: true});
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  buttonFormatter(cell, row, context) {
    if (row.status === 'new') {
      return (
        <button onClick={() => context.props.history.push("/applications/edit_" + row.uuid)}>Edit</button>
      );
    } else {
      return (
        <div>
          <button onClick={() => context.props.history.push("/applications/edit_" + row.uuid)}>View Application</button>
          {(row.status === 'error' || row.status === 'complete') &&
          <button onClick={() => context.props.history.push("/applications/submit_" + row.uuid)}>View Results</button>
          }
          {(row.status === 'processing') &&
          <button onClick={() => context.props.history.push("/applications/submit_" + row.uuid)}>See Progress</button>
          }
        </div>
      )
    }
  }

  render() {
    // var statusUpdate = function (cell, row) {
    //   var str = "";
    //   if (cell === 0 || cell === 1){
    //     str = "Drafting";
    //   } else {
    //     str = "Signed " + row.completed.split("T")[0];
    //   }
    //   return str;
    // }
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"></i>Customer Application Forms

              <div className="card-actions">
                <button onClick={() => this.props.history.push(`/applications/add`)}>
                  <small className="text-muted">Add</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <div style={{textAlign: 'right'}}>Click the Add button above to start a new Application.</div>
              <BootstrapTable data={this.state.data} version="4" striped hover pagination options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="display" dataSort>Display</TableHeaderColumn>
                <TableHeaderColumn dataField="status" dataSort>Status</TableHeaderColumn>
                <TableHeaderColumn dataField="created" dataSort>Created</TableHeaderColumn>
                <TableHeaderColumn dataField="lastupdated" dataSort>Updated</TableHeaderColumn>
                <TableHeaderColumn dataField="button"
                                   dataFormat={(cell, row) => this.buttonFormatter(cell, row, this)}>Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
          </Card>
        )}
      </div>
    )
  }
}

export default ApplicationsList;



// WEBPACK FOOTER //
// ./src/containers/Applications/ApplicationsList.js